import * as React from 'react';
import classNames from 'classnames';

import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';
import { useAppContext } from '../../../../../../../../../AppModulesWrapper';
import { ErrorWrapper } from '../ErrorWrapper';
import { photoIcon } from '../../icons';

import { useAnimation } from './hooks';

import * as styles from './NoPhotos.css';

export interface INoPhotosProps {
  serviceName: string;
}

export const NoPhotos = ({ serviceName }: INoPhotosProps) => {
  const { webview } = useAppContext();
  const { isAnimated } = useAnimation();

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('no-photos-unavailable-reason-banner-show'));
  }, [webview]);

  return (
    <div className={classNames(isAnimated && styles['shake-error'])}>
      <ErrorWrapper icon={photoIcon}>Добавьте фото, чтобы продвинуть объявление в&nbsp;{serviceName}</ErrorWrapper>
    </div>
  );
};
